import classNames from "classnames";
import React from "react";

interface TabsProps {
  activeTab: string;
  tabs: string[];
  setActiveTab: (tab: string) => void;
  className?: string;
}

const Tab = (props: TabsProps) => {
  const { activeTab, tabs, setActiveTab, } = props;
  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
  };
  return (
    <div className="flex w-full my-4 rounded-full bg-[#E6E6E6] py-1 px-2 gap-6">
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={classNames("text-normal text-[13px] p-3  w-full font-medium", {
            "shadow-md rounded-full border text-[#1D2939] bg-white": activeTab === tab,
            "border-none text-[#475467]": activeTab !== tab,
         
          })}
          onClick={() => handleTabClick(tab)}
        >
          {tab.charAt(0).toUpperCase() + tab.slice(1)}
        </button>
      ))}
    </div>
  );
};

export default Tab;